module.exports = __webpack_public_path__ + "static/media/envelope.3042df40.svg";